module.exports = __webpack_public_path__ + "05297273e2fca76161038249b3180b7f.png";